/**
 * @generated SignedSource<<594310d2253c9ef520ea9ac874b27d12>>
 * @relayHash cfb2611d7965ec725739d3a1ffd5cc4e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/578.0.0-2026-09-17T08:13:42.063Z/UserNotificationsQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsQuery$variables = {
  showPriceDropNotifications?: boolean | null;
  userId: string;
};
export type UserNotificationsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsIcon_viewer" | "UserNotificationsMarkAllAsRead_viewer">;
  };
};
export type UserNotificationsQuery = {
  response: UserNotificationsQuery$data;
  variables: UserNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showPriceDropNotifications"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "showPriceDropNotifications",
  "variableName": "showPriceDropNotifications"
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v4/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = [
  (v4/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotificationsTag",
    "kind": "LinkedField",
    "name": "unreadTag",
    "plural": false,
    "selections": (v6/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotificationsTag",
    "kind": "LinkedField",
    "name": "unviewedTag",
    "plural": false,
    "selections": (v6/*:: as any*/),
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "buyerMember",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnviewedTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnreadTag",
      "storageKey": null
    },
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotification",
  "kind": "LinkedField",
  "name": "all",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "payload",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v7/*:: as any*/),
          "type": "FavoriteNotification",
          "abstractKey": "__isFavoriteNotification"
        },
        {
          "kind": "InlineFragment",
          "selections": (v7/*:: as any*/),
          "type": "ActivityFeedElement",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v5/*:: as any*/)
          ],
          "type": "Node",
          "abstractKey": "__isNode"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v4/*:: as any*/),
            (v8/*:: as any*/)
          ],
          "type": "Conversation",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v3/*:: as any*/),
            "kind": "FragmentSpread",
            "name": "UserNotificationsMarkAllAsRead_viewer"
          },
          {
            "args": (v3/*:: as any*/),
            "kind": "FragmentSpread",
            "name": "UserNotificationsIcon_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UserNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v2/*:: as any*/),
              {
                "kind": "Variable",
                "name": "userId",
                "variableName": "userId"
              }
            ],
            "concreteType": "UserNotifications",
            "kind": "LinkedField",
            "name": "userNotifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationsBucket",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Conversation",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": true,
                    "selections": [
                      (v4/*:: as any*/),
                      (v5/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationsBucket",
                "kind": "LinkedField",
                "name": "earlier",
                "plural": false,
                "selections": [
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/578.0.0-2026-09-17T08:13:42.063Z/UserNotificationsQuery",
    "metadata": {},
    "name": "UserNotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "588f2edf1d4e807f1e72e60528ed015a";

export default node;
